
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormDialog from '@/components/dialogs/FormDialog.vue';
import NewFormDialog from '@/components/dialogs/NewFormDialog.vue';
import UyapIlamBilgileriForm from '@/components/eicrapro/UyapIlamBilgileriForm.vue';
import TakipHazirlaVekaletEkleDialog from '@/components/eicrapro/TakipHazirlaVekaletEkleDialog.vue';
import DayanakList from '@/components/eicrapro/DayanakList.vue';
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {TakipAcStatusEnum} from "@/plugins/uyap-plugin/takip_ac/parser/TakipAcStatusEnum";
import UyapTakipAc from "@/plugins/uyap-plugin/takip_ac/UyapTakipAc";
import MtsTakipAc from "@/plugins/uyap-plugin/takip_ac/MtsTakipAc";
import {
  AcilmisTakipBilgisi,
  isAcilmisTakipHatasi
} from "@/plugins/uyap-plugin/takip_ac/AcilmisTakipHatasi";
import {ACILMIS_TAKIP_SILME_KISITI_AKTIF} from "@/helpers/HashSilmeKisitiHelper";
import {hashKaydiniSil, kayitDurumuUyarisi, sihirbazKayitDurumu} from "@/helpers/HashSilmeHelper";
import {
  isSorgulanabilirIlamTuru,
  UyapIlamTuru
} from "@/plugins/uyap-plugin/takip_ac/IlamTuruKurallari";

@Component({
  components: {
    DeleteDialog,
    FormDialog,
    NewFormDialog,
    UyapIlamBilgileriForm,
    TakipHazirlaVekaletEkleDialog,
    DayanakList,
  },
})
export default class ActionsColumn extends Vue {
  @Prop({required: true}) readonly item!: UyapTakipAc | MtsTakipAc;
  @Prop({default: false}) readonly disabled!: boolean;
  @Prop({default: false}) readonly isMts!: boolean;

  takipAcStatusEnum = TakipAcStatusEnum;

  get storeModulu(): string {
    return this.isMts ? 'mtsTakipHazirla' : 'takipHazirla';
  }

  /** Hash kaydı bu sihirbazda silindi mi? Satır yeniden çalıştırılınca / yeni XML'de store sıfırlar. */
  get hashSilindi(): boolean {
    const silinenler: number[] = this.$store.getters[`${this.storeModulu}/hashSilinenTempIdler`] || [];
    return silinenler.includes(this.item.tempId);
  }

  get acilmisTakipBilgisi(): AcilmisTakipBilgisi | null {
    return this.item.acilmisTakipBilgisi || null;
  }

  /**
   * Hash'e ait takip UYAP'ta açılmış mı?
   * Bilgi nesnesi yoksa (ör. görevden geri yüklenmiş kayıt) mesajlardan tespit edilir.
   */
  get takipAcilmis(): boolean {
    if (this.acilmisTakipBilgisi) return true;
    return (this.item.messages || []).some(mesaj => isAcilmisTakipHatasi(mesaj.message));
  }

  /** Açılmış takipte hash silme kilitliyken çöp kutusu yerine bilgi ikonu çıkar. */
  get hashSilmeKilitli(): boolean {
    return ACILMIS_TAKIP_SILME_KISITI_AKTIF && this.takipAcilmis;
  }

  // Onay diyaloğu gövdesi kayıt durumuna göre; sunucu bilgisi olmadığı için satırın mesajlarından tahmin edilir.
  get silmeUyarisi(): string {
    return kayitDurumuUyarisi(sihirbazKayitDurumu(this.item));
  }

  get takipAcilmisTooltip(): string {
    const bilgi = this.acilmisTakipBilgisi;
    if (bilgi && (bilgi.icraDairesi || bilgi.dosyaEsasNo)) {
      const satirlar = ['Takip açılmış, hash silinemez.'];
      if (bilgi.icraDairesi) satirlar.push('İcra Dairesi: ' + bilgi.icraDairesi);
      if (bilgi.dosyaEsasNo) satirlar.push('Esas No: ' + bilgi.dosyaEsasNo);
      return satirlar.join('\n');
    }
    const mesaj = (this.item.messages || []).find(m => isAcilmisTakipHatasi(m.message));
    return mesaj ? mesaj.message : 'Takip açılmış, hash silinemez.';
  }

  get isIlamli(): boolean {
    if (this.isMts)
      return false;
    return (this.item as UyapTakipAc).parsedFile?.isIlamli();
  }

  /**
   * "Tam" olma koşulu ilam türüne göre değişir: UYAP'ta sorgulanabilen türlerde mahkeme +
   * dosya no ve başarılı eşleştirme, diğerlerinde kurum adı + ilam tarihi + türe özgü numara.
   * Eskiden tüm türler için mahkeme/dosya no aranıyordu; noter/hakem/arabuluculuk/diğer
   * türlerinde ikon hep kırmızı kalıyordu.
   */
  get isIlamBilgisiTam(): boolean {
    if (!this.item.parsedFile?.isIlamli()) return false;
    try {
      const ilam = this.item.parsedFile.getIlamBilgileri();
      if (!ilam) return false;
      if (isSorgulanabilirIlamTuru(ilam.ilamTuru)) {
        return !!(ilam.birimId && ilam.dosyaYil && ilam.dosyaSira)
            && this.item.parsedFile.ilamSorgusu?.status === true;
      }
      const kurumBilgisiTam = !!(ilam.ilamliKurumAdi && ilam.ilamTarihi);
      switch (Number(ilam.ilamTuru)) {
        case UyapIlamTuru.Noter:
        case UyapIlamTuru.Diger:
          return kurumBilgisiTam && !!(ilam.yevmiyeYil && ilam.yevmiyeSira);
        case UyapIlamTuru.HakemKarari:
          return kurumBilgisiTam && !!(ilam.kararDosyaYil && ilam.kararDosyaSira);
        case UyapIlamTuru.Arabuluculuk:
          return kurumBilgisiTam && !!(ilam.dosyaYil && ilam.dosyaSira && ilam.kararDosyaYil && ilam.kararDosyaSira);
        default:
          return kurumBilgisiTam;
      }
    } catch (e) {
      return false;
    }
  }

  get getIlamIconColor(): string {
    if (this.isIlamBilgisiTam) {
      return '#4CAF50';
    }
    return this.item.parsedFile.ilamSorgusu?.status ? '#64748b' : '#c62828';
  }

  get getIlamTooltip(): string {
    if (this.isIlamBilgisiTam) {
      return 'İlam bilgileri tam';
    }
    return 'UYAP İlam Bilgileri';
  }

  get hasVekalet(): boolean {
    return !!this.item.parsedFile?.vekalet || !!this.item.parsedFile?.vekaletObject?.id;
  }

  onIlamInput(item: UyapTakipAc | MtsTakipAc, payload: any): void {
    const ilam = (item as UyapTakipAc)?.parsedFile?.ilamliList?.[0];
    if (ilam && payload) {
      Object.assign(ilam, payload);
    }
  }

  handlePerRowVekaletSuccess(vekalet: any, onClose: () => void) {
    const isExistingVekalet = vekalet.id && !vekalet.data;
    if (isExistingVekalet) {
      this.item.parsedFile.vekaletObject = vekalet;
    } else {
      this.item.parsedFile.vekalet = vekalet;
    }
    onClose();
  }

  deleteHash(): Promise<void> {
    return hashKaydiniSil(this.$http, this.$toast, this.item.parsedFile?.hash || null);
  }

  onHashSilindi(): void {
    this.$store.commit(`${this.storeModulu}/HASH_SILINDI`, this.item.tempId);
  }
}
